import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import CharacterGrid from '../Resources/CharacterGrid/CharacterGrid';
import CheckBox from '../@common/CheckBox/CheckBox';
import FilterDropDown from '../@common/Dropdowns/FilterDropDown';
import { toggleTag, clearResourceFilters, setResourceFilters } from '../../state/modules/app';
import { AppStoreState, FilterTag } from 'types';
import { FONT_GSS_FUTURA } from 'themes/default';
import { InputAdornment, TextField } from '@mui/material';
import { translate } from 'translations/translator';
import { fetchFilterTags } from 'state/modules/entity/custom/resource-favorites-mutations/thunks/resource-thunks';

const ResourcesFilter = () => {
  const { selectedTags } = useSelector(({ app }: AppStoreState) => app.resource.selectedFilters);
  const [openFilter, setOpenFilter] = useState('');
  const { filterGroups } = useSelector(({ entity }: AppStoreState) => entity);
  const classes = useStyles();
  const dispatch = useDispatch() as any;
  const [displayedSearchText, setDisplayedSearchText] = useState('');
  const translateResources = key => translate('resources', key);

  React.useEffect(() => {
    dispatch(clearResourceFilters());
    dispatch(setResourceFilters('', []));
    dispatch(fetchFilterTags());
  }, [dispatch]);

  const handleFilterToggle = (filter: any) => {
    dispatch(toggleTag(filter));
  };

  const clearFilters = () => {
    dispatch(clearResourceFilters());
    dispatch(setResourceFilters('', []));
    setDisplayedSearchText('');
  };

  function renderGrid(filterTags: Array<FilterTag>) {
    return (
      <CharacterGrid
        items={filterTags}
        selectedItems={selectedTags}
        onSelectItem={handleFilterToggle}
      />
    );
  }
  const setSearchText = (newSearchText: string) => {
    setDisplayedSearchText(newSearchText);
    if (newSearchText.length > 2 || displayedSearchText !== '') {
      dispatch(setResourceFilters(newSearchText, []));
    }
  };
  function renderDynamicFilters(filterTags: Array<FilterTag>): any {
    let checked = false;
    if (filterTags[0].componentType === 'button') {
      return renderGrid(filterTags);
    } else {
      return filterTags.map((filterTag: FilterTag, index: number): React.ReactElement => {
        checked = selectedTags.findIndex(tag => tag.id === filterTag.id) !== -1;

        return (
          <CheckBox
            key={index}
            label={filterTag.value}
            checked={checked} // [TODO: check if is selectedTag
            onChange={() => handleFilterToggle(filterTag)}
          />
        );
      });
    }
  }

  function renderDynamicFilterGroups(): Array<React.ReactElement> {
    return filterGroups.map((filterGroup: any, index: number): React.ReactElement => {
      return (
        <FilterDropDown
          key={index}
          label={filterGroup.filter}
          setOpenFilter={setOpenFilter}
          openFilter={openFilter}
          selectedTags={selectedTags}
          filterGroupValues={filterGroup.values}
          openByDefault={
            filterGroup.values.find(filter => selectedTags.indexOf(filter.id) >= 0) !== undefined
          }
        >
          {renderDynamicFilters(filterGroup.values)}
        </FilterDropDown>
      );
    });
  }

  return (
    <div style={{ width: '100%', display: 'flex', alignSelf: 'center' }}>
      <div className={classes.filterGroupsDiv}>
        {renderDynamicFilterGroups()}{' '}
        <div className={classes.clearFilters}>
          <Button
            startIcon={<FontAwesomeIcon icon={faTimes} size="lg" />}
            style={
              {
                margin: '10px',
                verticalAlign: 'center',
                color: '#2878C1',
                width: '158px',
                '&:hover': {
                  opacity: 0.8
                }
              } as any
            }
            onClick={clearFilters}
          >
            <span style={{ marginTop: 5 }}>Clear Filters</span>
          </Button>
        </div>
      </div>
      <div className={classes.searchBar}>
        <TextField
          onChange={event => setSearchText(event.target.value)}
          value={displayedSearchText}
          placeholder={translateResources('search')}
          fullWidth={true}
          variant="outlined"
          sx={{
            backgroundColor: 'white',
            borderRadius: '8px'
          }}
          InputProps={{
            disableUnderline: true,
            style: {
              width: '350px',
              height: '43px',
              fontWeight: '400 !important',
              border: '2px solid',
              borderRadius: '8px'
            },
            endAdornment: (
              <InputAdornment position="end">
                <FontAwesomeIcon icon={faSearch} />
              </InputAdornment>
            )
          }}
        />
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  filterGroupsDiv: {
    float: 'left',
    display: 'flex',
    width: '250px',
    marginLeft: '30px'
  },
  clearFilters: {
    paddingTop: '20px',
    fontSize: '12px',
    lineHeight: '18px',
    fontFamily: FONT_GSS_FUTURA
  },
  searchBar: {
    position: 'absolute',
    right: 60,
    top: 7,
    width: 350,
    zIndex: 10
  }
});

export default ResourcesFilter;
